import { useState } from 'react';
// import { config } from '../../../config';
import { fetcher } from '../helpers/fetcher';
import { apiLinks } from '../config/configApiLinks';
import { useAuth } from './useAuth';

export const useFindProduct = () => {
    const { authState } = useAuth();
    const [productData, setProductData] = useState(null);
    const [resNotFound, setResNotFound] = useState(false);
    // console.log('useFindProduct->authState', authState);
    const findProductByBarcode = async (inBarcode) => {
        try {
            const findedProduct = await fetcher(apiLinks.findByBarcode, 'POST',
                { barcode: inBarcode },
                true,
                authState.user.token
            );
            // console.log('findProductByBarcode', findedProduct);
            if (findedProduct) {
                setProductData(findedProduct);
                setResNotFound(false);
            } else {
                setProductData(null);
                setResNotFound(true);
            }
        } catch (error) {
            setProductData(null);
            setResNotFound(true);
            // console.error('search error:', error);
        }
    };

    return { productData, findProductByBarcode, resNotFound, setResNotFound };
};
